<script setup lang="ts">
import { useModalStore } from '@/shared/ui/AppModal/store/modal';
import type { ILawyerDetail } from '@/entities/lawyer/model/types/lawyer';

const modalStore = useModalStore();
const lawyerInfo = inject<ILawyerDetail>('lawyerInfo');

const showCallbackModal = (): void => {
  modalStore.setModalState('callback', true, { lawyerInfo });
};
</script>

<template>
  <div class="footer-contacts">
    <AppButton
      class="footer-contacts__button"
      is-big
      button-text="Задать вопрос"
      left-icon-name="Mail"
      left-icon-width="20"
      left-icon-height="20"
      is-hover-pulse-effect
      @click="showCallbackModal"
    />
    <div class="footer-contacts__social">
      <div class="footer-contacts__social-text">Бесплатный ответ:</div>
      <div class="footer-contacts__social-items">
        <AppIcon name="PhoneCallbackModal" />
        <AppIcon name="ChatCallbackModal" />
        <AppIcon name="Telegram" />
        <AppIcon name="Whatsapp" />
      </div>
    </div>
  </div>
</template>

<style lang="less">
.footer-contacts {
  .flex-column(@size-x4);

  align-items: flex-end;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;

  &__button {
    .app-button__icon path {
      stroke: #fff;
    }

    &.app-button._big {
      width: 255px;
    }
  }

  &__social {
    display: flex;
    gap: 10px;
  }

  &__social-items {
    display: flex;
    align-items: center;
    gap: @size-x3;
  }

  &__social-text {
    font-size: 14px;
    font-weight: 500;
    line-height: 130%;
  }
}
</style>
